import { z } from 'zod';

export const childLimitExceedsParentCeilingDetailSchema = z.object({
  statKey: z.string(),
  excessCatalogIds: z.array(z.string()),
});

export type ChildLimitExceedsParentCeilingDetail = z.infer<
  typeof childLimitExceedsParentCeilingDetailSchema
>;

export const childLimitExceedsParentCeilingErrorSchema = z.object({
  message: z.string().optional(),
  code: z.literal('CHILD_LIMIT_EXCEEDS_PARENT_CEILING'),
  details: z.array(childLimitExceedsParentCeilingDetailSchema),
});

export type ChildLimitExceedsParentCeilingError = z.infer<
  typeof childLimitExceedsParentCeilingErrorSchema
>;

/** Other stat-access API error bodies before a specific code is narrowed. */
export type StatAccessLooseErrorResponse = {
  message?: string;
  code?: string;
  details?: Record<string, unknown>;
};

/** Error bodies returned by stat access column-catalog / limit APIs. */
export type StatAccessErrorResponse =
  | ChildLimitExceedsParentCeilingError
  | StatAccessLooseErrorResponse;

/**
 * Values accepted by stat-access error helpers: parsed API errors, drift detail
 * rows already extracted into state, or loosely-shaped pre-parse responses.
 */
export type StatAccessErrorInput =
  | StatAccessErrorResponse
  | ChildLimitExceedsParentCeilingDetail[]
  | null
  | undefined;

const childLimitDriftDetailsSchema = z.array(childLimitExceedsParentCeilingDetailSchema);

export function parseChildLimitExceedsParentCeilingError(
  data: StatAccessErrorInput,
): ChildLimitExceedsParentCeilingError | null {
  const parsed = childLimitExceedsParentCeilingErrorSchema.safeParse(data);
  return parsed.success ? parsed.data : null;
}

export function parseChildLimitDriftDetails(
  data: StatAccessErrorInput,
): ChildLimitExceedsParentCeilingDetail[] | null {
  if (Array.isArray(data)) {
    const parsed = childLimitDriftDetailsSchema.safeParse(data);
    return parsed.success ? parsed.data : null;
  }

  const driftError = parseChildLimitExceedsParentCeilingError(data);
  return driftError?.details ?? null;
}
